import Layout from "../../components/Layout";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

import "./style.css";

const ViewContract = () => {
  return (
    <Layout>
      <div className="contract-layout">
        <div className="view-form">
          <Form.Group>
            <label className="mb-2">İsim Soyisim</label>
            <Form.Control type="text" placeholder="Şevval Karadağ" />
          </Form.Group>
          <Form.Group>
            <label className="mb-2">Görüntülemek İçin Seçiniz:</label>
            <Form.Select>
              <option value="Aktif">Abonelik Sözleşmesi</option>
              <option value="Aktif">Satış Sözleşmesi</option>
              <option value="Aktif">Üye Sözleşmesi</option>
            </Form.Select>
          </Form.Group>
          <Form.Group>
            <label htmlFor="birthday">Dosya Yükle:</label>
            <Form.Control type="file" />
          </Form.Group>
          <div className="button-wrapper">
            <Button variant="secondary">İptal</Button>
            <Button variant="primary">Kaydet</Button>
          </div>
        </div>
        <div className="contract">
          <img
            src="https://esign.com/wp-content/uploads/Service-Contract-Template.png"
            alt="contract"
          />
        </div>
      </div>
    </Layout>
  );
};

export default ViewContract;
